@if (userSelections) {
  <div class="content">
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="systemType">System Type:</label>
        <select class='selectionInput' name="systemType" id="systemType" #systemTypeInput
          (change)="validateSelections('USSystemType', systemTypeInput.value)"
          [class.invalid]="isInvalid('USSystemType')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USSystemType'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USSystemType')"
              [class.disabled]="!isSelectionValid('USSystemType', selection.Value)" [value]="selection.Value">
            {{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="riserAttachmentMethod">Riser Attachment Method:</label>
        <select class='selectionInput' name="riserAttachmentMethod" id="riserAttachmentMethod" #riserAttachmentInput
          (change)="validateSelections('USRiserAttachmentMethod', riserAttachmentInput.value)"
          [class.invalid]="isInvalid('USRiserAttachmentMethod')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USRiserAttachmentMethod'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USRiserAttachmentMethod')"
              [class.disabled]="!isSelectionValid('USRiserAttachmentMethod', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="riserVendorInput">Riser Supplier:</label>
        <select class='selectionInput' name="riserVendorInput" id="riserVendorInput" #riserVendorInput
          (change)="validateSelections('USRiserVendor', riserVendorInput.value)"
          [class.invalid]="isInvalid('USRiserVendor')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USRiserVendor'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USRiserVendor')"
              [class.disabled]="!isSelectionValid('USRiserVendor', selection.Value)"
              [value]="selection.Value">
            {{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="bottomInsulationCutback">Riser Bottom Insulation Cutback:</label>
        <select class='selectionInput' name="bottomInsulationCutback" id="bottomInsulationCutback" #bottomCutbackInput
          (change)="validateSelections('USInsulationCutbackBottom', bottomCutbackInput.value)"
          [class.invalid]="isInvalid('USInsulationCutbackBottom')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USInsulationCutbackBottom'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USInsulationCutbackBottom')"
              [class.disabled]="!isSelectionValid('USInsulationCutbackBottom', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="topInsulationCutback">Riser Top Insulation Cutback:</label>
        <select class='selectionInput' name="topInsulationCutback" id="topInsulationCutback" #topCutbackInput
          (change)="validateSelections('USInsulationCutbackTop', topCutbackInput.value)"
          [class.invalid]="isInvalid('USInsulationCutbackTop')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USInsulationCutbackTop'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USInsulationCutbackTop')"
              [class.disabled]="!isSelectionValid('USInsulationCutbackTop', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="endTreatment">Riser End Treatment:</label>
        <select class='selectionInput' name="endTreatment" id="endTreatment" #endTreatmentInput
          (change)="validateSelections('USEndTreatment', endTreatmentInput.value)"
          [class.invalid]="isInvalid('USEndTreatment')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USEndTreatment'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USEndTreatment')"
              [class.disabled]="!isSelectionValid('USEndTreatment', selection.Value)"
              [value]="selection.Value">
            {{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="topStandoff">Riser Connection Height:</label>
        <select class='selectionInput' name="topStandoff" id="topStandoff" #topStandoffInput
          (change)="validateSelections('USTopStandoff', topStandoffInput.value)"
          [class.invalid]="isInvalid('USTopStandoff')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USTopStandoff'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USTopStandoff')"
              [class.disabled]="!isSelectionValid('USTopStandoff', selection.Value)"
              [value]="selection.Value">
            {{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <div class="selectionHeader">Cold Water Riser Options</div>
      <span class="selection">
        <label class='selectionLabel' for="coldCopperType">Cold Water Copper Type:</label>
        <select class='selectionInput' name="coldCopperType" id="coldCopperType" #coldCopperInput
          (change)="validateSelections('USColdRiserCopperType', coldCopperInput.value)"
          [class.invalid]="isInvalid('USColdRiserCopperType')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USColdRiserCopperType'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USColdRiserCopperType')"
              [class.disabled]="!isSelectionValid('USColdRiserCopperType', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="coldSupplyInsulation">Cold Supply Insulation:</label>
        <select class='selectionInput' name="coldSupplyInsulation" id="coldSupplyInsulation" #coldSupplyInsulationInput
          (change)="validateSelections('USCSInsulationThickness', coldSupplyInsulationInput.value)"
          [class.invalid]="isInvalid('USCSInsulationThickness')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USCSInsulationThickness'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USCSInsulationThickness')"
              [class.disabled]="!isSelectionValid('USCSInsulationThickness', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="coldReturnInsulation">Cold Return Insulation:</label>
        <select class='selectionInput' name="coldReturnInsulation" id="coldReturnInsulation" #coldReturnInsulationInput
          (change)="validateSelections('USCRInsulationThickness', coldReturnInsulationInput.value)"
          [class.invalid]="isInvalid('USCRInsulationThickness')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USCRInsulationThickness'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USCRInsulationThickness')"
              [class.disabled]="!isSelectionValid('USCRInsulationThickness', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <div class="selectionHeader">Drain Riser Options</div>
      <span class="selection">
        <label class='selectionLabel' for="drainCopperType">Drain Riser Copper Type:</label>
        <select class='selectionInput' name="drainCopperType" id="drainCopperType" #drainCopperInput
          (change)="validateSelections('USDRRiserCopperType', drainCopperInput.value)"
          [class.invalid]="isInvalid('USDRRiserCopperType')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USDRRiserCopperType'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USDRRiserCopperType')"
              [class.disabled]="!isSelectionValid('USDRRiserCopperType', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="drainInsulation">Drain Insulation Thickness:</label>
        <select class='selectionInput' name="drainInsulation" id="drainInsulation" #drainInsulationInput
          (change)="validateSelections('USDRInsulationThickness', drainInsulationInput.value)"
          [class.invalid]="isInvalid('USDRInsulationThickness')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USDRInsulationThickness'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USDRInsulationThickness')"
              [class.disabled]="!isSelectionValid('USDRInsulationThickness', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <div class="selectionHeader">Hot Water Riser Options</div>
      <span class="selection">
        <label class='selectionLabel' for="hotCopperType">Hot Water Copper Type:</label>
        <select class='selectionInput' name="hotCopperType" id="hotCopperType" #hotCopperInput
          (change)="validateSelections('USHotRiserCopperType', hotCopperInput.value)"
          [class.invalid]="isInvalid('USHotRiserCopperType')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USHotRiserCopperType'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USHotRiserCopperType')"
              [class.disabled]="!isSelectionValid('USHotRiserCopperType', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
      <span class="selection">
        <label class='selectionLabel' for="hotSupplyInsulation">Hot Supply Insulation:</label>
        <select class='selectionInput' name="hotSupplyInsulation" id="hotSupplyInsulation" #hotSupplyInsulationInput
          (change)="validateSelections('USHSInsulationThickness', hotSupplyInsulationInput.value)"
          [class.invalid]="isInvalid('USHSInsulationThickness')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USHSInsulationThickness'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USHSInsulationThickness')"
              [class.disabled]="!isSelectionValid('USHSInsulationThickness', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="selectionRow">
      <span class="selection">
        <label class='selectionLabel' for="hotReturnInsulation">Hot Return Insulation:</label>
        <select class='selectionInput' name="hotReturnInsulation" id="hotReturnInsulation" #hotReturnInsulationInput
          (change)="validateSelections('USHRInsulationThickness', hotReturnInsulationInput.value)"
          [class.invalid]="isInvalid('USHRInsulationThickness')">
          <option value="" [disabled]="true">Please select</option>
          @for (selection of getAllowableValues('USHRInsulationThickness'); track selection) {
            <option
              [selected]="selection.Value === getSelectedValue('USHRInsulationThickness')"
              [class.disabled]="!isSelectionValid('USHRInsulationThickness', selection.Value)"
            [value]="selection.Value">{{ selection.Description }}</option>
          }
        </select>
      </span>
    </div>
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
